module.exports = __webpack_public_path__ + "static/media/ilustracion-container.8e04c670.png";